import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UrlModule } from '@spartacus/core';
import { CartModule } from './cart.module';
import { staticRoutes } from './custom-static-routes';
import { MyAccountRoutesModule } from './my-account-routes.module';
import { OrderFormRoutesModule } from './order-form-routes.module';
import { PageRoutesModule } from './page.routes.module';
import { ProductRoutesModule } from './product-routes.module';
import { QuickOrderRoutesModule } from './quick-order-routes.module';
import { SavedCartRoutesModule } from './saved-cart-routes.module';

/**
 * This feature demonstrates the routing in Spartacus.
 *
 * In this code you'll find a demonstration of:
 * - CMS based routes, rendered with custom page component
 * - Custom (static) route, connected to CMS data
 * - The usage of the `routerLink` with the Spartacus `cxUrl` pipe
 * - Configuration of product routes (SEO, aliases) with additional (normalized) product data
 */
@NgModule({
  imports: [
    // dependend module for semantic URLs
    UrlModule,
    // demonstrate custom product route configurations
    ProductRoutesModule,
    CartModule,
    MyAccountRoutesModule,
    PageRoutesModule,
    QuickOrderRoutesModule,
    SavedCartRoutesModule,
    OrderFormRoutesModule,
    // standard non-spartacus routes
    RouterModule.forRoot(staticRoutes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  declarations: [],
  exports: [RouterModule],
})
export class AppRoutingModule {}
